import { styled } from '@mui/material/styles';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  loaderBox: 'loaderBox',
  otpInputBoxes: 'otpInputBoxes',
  otpSingleBox: 'otpSingleBox',
  otpSubmitButton: 'otpSubmitButton',
  otpSubmitTypography: 'otpSubmitTypography',
  expiryTypography: 'expiryTypography',
  logoBox: 'logoBox',
  rightGrid: 'rightGrid',
  rightGridMainBox: 'rightGridMainBox',
  welcomeHeader: 'welcomeHeader',
  rightBoxInfoSubtitle: 'rightBoxInfoSubtitle',
  rightBoxInfoSubtitleError: 'rightBoxInfoSubtitleError',
  containerMainGrid: 'containerMainGrid',
  resendButton: 'resendButton',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.pageNotFoundContainer}`]: {
    backgroundColor: theme.palette.darkPurple.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
  },
  [`& .${classes.otpInputBoxes}`]: {
    [up('xs')]: {
      height: '15vh',
      width: '60vw',
    },
    [up('sm')]: {
      height: '15vh',
      width: '34vw',
    },
    [up('md')]: {
      height: '15vh',
      width: '27vw',
    },
    [up('lg')]: {
      height: '15vh',
      width: '25vw',
    },
    [up('xl')]: {
      height: '15vh',
      width: '23vw',
    },
    [up('xxl')]: {
      height: '15vh',
      width: '20vw',
    },
  },
  [`& .${classes.otpInput}`]: {
    [up('xs')]: {
      height: '15vh',
      width: '60vw',
    },
  },
  [`& .${classes.otpSingleBox} > div`]: {
    [up('xs')]: {
      width: '20px',
      height: '20px',
    },
    [up('sm')]: {
      width: '32px',
      height: '36px',
    },
    [up('md')]: {
      width: '40px',
      height: '40px',
    },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.secondaryWhite.main,
  },
  [`& .${classes.otpSingleBox} > div > input`]: {
    textAlign: 'center',
    [up('xs')]: {
      fontSize: '10px',
      padding: 0,
    },
    [up('sm')]: {
      fontSize: '12px',
      padding: 0,
    },
    [up('md')]: {
      fontSize: '15px',
    },
  },
  [`& .${classes.otpSubmitButton}`]: {
    marginTop: '15px',
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.darker,
    },
    [up('xs')]: {
      height: '20px',
    },
    [up('sm')]: {
      height: '23px',
    },
    [up('md')]: {
      height: '30px',
    },
    [up('lg')]: {
      height: '35px',
    },
    [up('xl')]: {
      height: '35px',
    },
    [up('xxl')]: {
      height: '35px',
    },
  },
  [`& .${classes.otpSubmitTypography}`]: {
    margin: '5px 0px',
  },
  [`& .${classes.expiryTypography}`]: {
    marginTop: '10px',
  },
  [`& .${classes.rightGridMainBox}`]: {
    width: '38vw',
    display: 'flex',
    justifyContent: 'center',
  },
  [`& .${classes.containerMainGrid}`]: {
    background: 'rgba(255, 255, 255, 1)',
    height: '100vh',
  },
  [`& .${classes.rightGrid}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [`& .${classes.logoBox}`]: {
    marginBottom: '15px',
    [up('xs')]: {
      width: '90px',
    },
    [up('sm')]: {
      width: '60px',
    },
    [up('md')]: {
      width: '80px',
    },
    [up('lg')]: {
      width: '100px',
    },
    [up('xl')]: {
      width: '140px',
    },
    [up('xxl')]: {
      width: '170px',
    },
  },
  [`& .${classes.logoIcon}`]: {
    position: 'fixed',
    top: 20,
  },
  [`& .${classes.welcomeHeader}`]: {
    margin: '1vh 0',
  },
  [`& .${classes.rightBoxInfoSubtitle}`]: {
    [up('xs')]: {
      marginBottom: '8px',
    },
    [up('sm')]: {
      marginBottom: '10px',
    },
    [up('md')]: {
      marginBottom: '16px',
    },
    [up('lg')]: {
      marginBottom: '24px',
    },
    [up('xl')]: {
      marginBottom: '34px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
    },
  },
  [`& .${classes.rightBoxInfoSubtitleError}`]: {
    [up('xs')]: {
      marginBottom: '8px',
      fontSize: '10px',
    },
    [up('sm')]: {
      marginBottom: '10px',
      fontSize: '10px',
    },
    [up('md')]: {
      marginBottom: '16px',
      fontSize: '10px',
    },
    [up('lg')]: {
      marginBottom: '24px',
      fontSize: '12px',
    },
    [up('xl')]: {
      marginBottom: '34px',
      fontSize: '15px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
      fontSize: '20px',
    },
  },
  [`& .${classes.actionButtonsContainer}`]: {
    padding: '0 25px 20px 25px',
  },
  [`& .${classes.conformationOkButtonLink}`]: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
  },
  [`& .${classes.pageNotFoundTextContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.pageNotFoundLogo}`]: {
    width: '120px',
    height: '120px',
  },
  [`& .${classes.pageNotFoundDescriptionText}`]: {
    color: theme.palette.secondaryWhite.dark,
    marginBottom: '5vh',
  },
  [`& .${classes.backButtonLink}`]: {
    textDecoration: 'none',
  },
  [`& .${classes.backButton}`]: {
    padding: '10px',
    color: theme.palette.secondaryWhite.main,
  },

  [`& .${classes.copyRightText}`]: {
    color: theme.palette.secondaryWhite.dark,
    position: 'fixed',
    bottom: 10,
    width: '100vw',
    textAlign: 'center',
  },
  [`& .${classes.resendButton}`]: {
    color: theme.palette.secondaryWhite.main,
  },
}));
